 
import React, { useRef } from 'react';
import './Footer.css';
import FooterLogo from '../../assets/images/footer-logo.webp';
import Swal from 'sweetalert2';

const Footer = () => {
  const form = useRef();

  const sendNewsletter = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData(form.current);

      // ✅ Web3Forms fields
      formData.append("access_key", "43724a9f-7d6d-4af0-8b23-c377deb489b5");
      formData.append("subject", "New Newsletter Subscription");

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        Swal.fire({
          title: "Subscribed!",
          text: "You have successfully subscribed.",
          icon: "success"
        });

        form.current.reset();
      } else {
        throw new Error(result.message);
      }

    } catch (error) {
      console.error("Newsletter Error:", error);

      Swal.fire({
        title: "Error",
        text: error.message || "Something went wrong. Try again.",
        icon: "error"
      });
    }
  };

  return(
    <>
    <footer className="footer-sec">

        <div className="newsletter-sec">
            <div className="container">
                <div className="row">
                    <div className="col-md-4">
                        <div className="newsletter-cont-wrp">
                            <h2>Subscribe to <br/>Our Newsletter</h2>
                        </div>
                    </div>

                    <div className="col-md-8">
                        <div className="newsletter-inner-wrp newsletter-form">

                            {/* ✅ EXACT SAME STRUCTURE */}
                            <form ref={form} onSubmit={sendNewsletter}>
                                <p>
                                    <input 
                                      type="email" 
                                      placeholder="Email" 
                                      name="email" 
                                      className="email" 
                                      required 
                                    />

                                    {/* ✅ ONLY change: button → submit */}
                                    <input 
                                      type="submit" 
                                      className="submit-btn" 
                                      value="" 
                                    /> 
                                </p>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="footer-main-wrp">
            <div className="container">
                <div className="row">

                    <div className="col-md-4">
                        <div className="social-media-wrp">
                            <figure>
                                <img src={FooterLogo} alt="Logo" width="200" />
                            </figure>
                            <ul>
                                <li>
                                  <a href="https://x.com/">
                                    <span>
                                      <i className="fa-brands fa-twitter"></i>
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="https://www.facebook.com/">
                                    <span>
                                      <i className="fa-brands fa-facebook-f"></i>
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="https://www.instagram.com/">
                                    <span>
                                      <i className="fa-brands fa-instagram"></i>
                                    </span>
                                  </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="work-time-wrp">
                            <h3>Our work time</h3>
                            <ul>
                                <li>
                                  <span>Monday - Friday</span>
                                  <span>09:00 am - 17:00 pm</span>
                                </li>
                                <li>
                                  <span>Saturday</span>
                                  <span>10:00 am - 15:00 pm</span>
                                </li>
                                <li>
                                  <span>Sunday</span>
                                  <span>We are closed</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="footer-address-wrp">
                            <ul>
                                <li>
                                    <span>
                                      <i className="fa-solid fa-location-dot"></i>
                                    </span>
                                    <span>Mumbai, Maharashtra</span>
                                </li>
                                <li>
                                    <span>
                                      <i className="fa-solid fa-envelope"></i>
                                    </span>
                                    <span>
                                      <a href="mailto:info@themefantasy.com">info@themefantasy.com</a>
                                    </span>
                                </li>
                                <li>
                                    <span>
                                      <i className="fa-solid fa-phone"></i>
                                    </span>
                                    <span>
                                      <a href="tel:+09773561830">+09773561830</a>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="copyright-inner-wrp">
                            <p>2025 Themefantasy All right reserved.</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </footer>
    </>
  )
}

export default Footer;
 